<!--系统管理页面弹窗组件  :rules="rules"-->
<template>
  <el-dialog
    :title="showTitle"
    :visible="show"
    width="60%"
    :close-on-click-modal="false"
    :before-close="closeWindow"
    class="dialog_container"
  >
    <el-row :gutter="10" class="dialogBtns">
      <el-button
        style="margin: 0 5%"
        :type="display === 0 ? 'primary' : 'info'"
        @click="sendMsg"
        >派发信息
      </el-button>
      <el-button
        style="margin: 0 5%"
        :type="display === 1 ? 'primary' : 'info'"
        @click="disposeMsg"
        >处理信息
      </el-button>
      <el-button
        v-show="btnActive"
        :type="display === 3 ? 'primary' : 'info'"
        @click="callbackingMag"
      >
        处理中回访信息
      </el-button>
      <el-button
        v-if="!dealFlag"
        v-show="btnActive"
        style="margin: 0 5%"
        :type="display === 2 ? 'primary' : 'info'"
        @click="callbackMag"
        >回访信息
      </el-button>
      <el-button
        v-show="btnActive"
        :type="display === 4 ? 'primary' : 'info'"
        @click="InfoMag"
        >补充资料
      </el-button>
    </el-row>
    <CallbackVisitDialog
      ref="CallbackVisitDialog"
      @updateList="getDataList"
      :orderInfo="serverObj"
      v-show="display === 0"
    ></CallbackVisitDialog>
    <!-- 处理信息 -->
    <div v-show="display === 1">
      <div style="height: 12px"></div>
      <el-form
        label-width="180px"
        ref="form"
        :model="serverObj"
        :disabled="!dealFlag"
      >
        <el-form-item label="APP用户反馈语音评价：">
          <el-input v-model="serverObj.evaluate"></el-input>
        </el-form-item>
        <audio
          controls="controls"
          preload="auto"
          class="audioActive"
          :src="serverObj.estimateRecord"
        ></audio>

        <el-row>
          <el-col :span="12">
            <el-form-item label="开始时间：">
              <el-date-picker
                v-model="serverObj.timeStart"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间：">
              <el-date-picker
                v-model="serverObj.timeEnd"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="服务内容：">
          <el-input type="textarea" v-model="serverObj.visitContent"></el-input>
        </el-form-item>
        <el-form-item label="工作图片：">
          <el-row :gutter="10">
            <el-col :span="6" class="imgBox">
              <!-- <img
                                v-if="serverObj.picStart"
                                :src="serverObj.picStart"
                                alt="工作开始图片"
                            /> -->
              <el-image
                v-if="serverObj.picStart"
                :src="serverObj.picStart"
                class="img"
                :preview-src-list="[serverObj.picStart]"
              ></el-image>
              <div class="photoName">工作开始</div>
            </el-col>
            <el-col :span="6" class="imgBox">
              <!-- <img
                                v-if="serverObj.picFinished"
                                :src="serverObj.picFinished"
                                alt="工作结束图片"
                            /> -->
              <el-image
                v-if="serverObj.picFinished"
                :src="serverObj.picFinished"
                class="img"
                :preview-src-list="[serverObj.picFinished]"
              ></el-image>
              <div class="photoName">工作结束</div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="工作视频：">
          <div class="uploadBox">
            <div class="uploadFlex">
              <!-- {{gongdanForm.video}} -->
              <video
                id="myvideo1"
                :src="serverObj.vidoeUrl"
                style="height: 100px; width: 200px; margin: 0 10px"
                ref="videoId"
                autoplay="true"
                controls
                muted
              ></video>
            </div>
          </div>
        </el-form-item>
        <!--                <el-divider></el-divider>-->
        <!--                <div style="height: 12px; margin-top: 30px; color: #169bd5">-->
        <!--                    是否合格-->
        <!--                </div>-->
        <!-- <el-divider></el-divider>
        <el-form-item label="状态：" prop="active">
          <el-radio-group
              v-model="serverObj.active"
              @change="disqualificationFun"
          >
            <el-radio label="合格"></el-radio>
            <el-radio label="不合格"></el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
    </div>
    <!--  处理中回访信息 -->
    <div v-show="display === 3">
      <div style="height: 12px; margin-top: 30px; color: #169bd5">
        处理中回访信息
      </div>
      <el-divider></el-divider>
      <el-form label-width="180px" ref="form" :model="serverObj">
        <el-form-item label="客户名称：">
          <el-col :span="10">
            <el-input disabled v-model="serverObj.customerName"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="联系方式：">
          <el-row :gutter="10">
            <el-col :span="10">
              <el-input disabled v-model="serverObj.customerphone"></el-input>
            </el-col>
            <el-col :span="1">
              <i
                class="el-icon-phone"
                title="电话"
                @click="callPhone(serverObj.customerphone, '1')"
              ></i>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="服务人员是否准时：">
          <el-radio-group disabled v-model="serverObj.isOnTime">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务态度是否良好：">
          <el-radio-group disabled v-model="serverObj.isGood">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务时间是否符合规范：">
          <el-radio-group disabled v-model="serverObj.isStandard">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务人员着装是否整洁：">
          <el-radio-group disabled v-model="serverObj.isTidy">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拨打状态：" prop="dialingStatus">
          <el-radio-group v-model="serverObj.dialingStatus" disabled>
            <el-radio label="0">正常接听</el-radio>
            <el-radio label="1">无人接听</el-radio>
            <el-radio label="2">关机</el-radio>
            <el-radio label="3">停机</el-radio>
            <el-radio label="4">空号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务对象评价：">
          <el-input
            disabled
            type="textarea"
            v-model="serverObj.ojectEvaluation"
          ></el-input>
        </el-form-item>
        <audio
          controls="controls"
          preload="auto"
          class="audioActive"
          :src="serverObj.estimateVoiceRecord"
        ></audio>
      </el-form>
    </div>
    <!-- 回访信息 -->
    <div v-show="display === 2" v-if="!dealFlag">
      <div style="height: 12px; margin-top: 30px; color: #169bd5">回访信息</div>
      <el-divider></el-divider>
      <el-form label-width="180px" ref="form" :model="serverObj" disabled>
        <el-form-item label="客户名称：">
          <el-col :span="10">
            <el-input v-model="serverObj.customerName"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="联系方式：">
          <el-row :gutter="10">
            <el-col :span="10">
              <el-input v-model="serverObj.customerphone"></el-input>
            </el-col>
            <el-col :span="1">
              <i
                class="el-icon-phone"
                title="电话"
                @click="callPhone(serverObj.customerphone, '1')"
              ></i>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <audio
            controls="controls"
            style="margin-left: 0"
            preload="auto"
            class="audioActive"
            :src="serverObj.recVisit"
          ></audio>
        </el-form-item>
        <el-form-item label="图片：">
          <el-upload
            :action="actionUrl"
            :show-file-list="false"
            :on-success="
              (file, fileList) => {
                handleAvatarSuccess1(file, fileList)
              }
            "
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png"
          >
            <div class="avatar" v-if="serverObj.pictureVisit">
              <img
                :src="serverObj.pictureVisit"
                style="width: 178px; height: 178px"
              />
            </div>
            <div v-else>
              <i
                class="el-icon-plus avatar_uploader avatar-uploader-icon"
                style="border: 1px solid #ddd"
              ></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="是否通过App处理工单：" prop="fromApps">
          <el-radio-group v-model="serverObj.fromApps">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传图片是否符合规范：" prop="rightPic">
          <el-radio-group v-model="serverObj.rightPic">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务时间是否符合规范：" prop="rightTime">
          <el-radio-group v-model="serverObj.rightTime">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否上传语音评价：" prop="rightEstimateRecord">
          <el-radio-group v-model="serverObj.rightEstimateRecord">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拨打状态：" prop="dialStatus">
          <el-radio-group v-model="serverObj.dialStatus">
            <el-radio label="0">正常接听</el-radio>
            <el-radio label="1">无人接听</el-radio>
            <el-radio label="2">关机</el-radio>
            <el-radio label="3">停机</el-radio>
            <el-radio label="4">空号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务对象评价：">
          <el-input type="textarea" v-model="serverObj.estimate"></el-input>
        </el-form-item>
        <el-form-item label="服务企业（组织）评价：">
          <el-input
            type="textarea"
            v-model="serverObj.jiamengEstimate"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户满意度：">
          <el-select v-model="serverObj.estimateLevel" placeholder="请选择">
            <el-option
              v-for="item in estimateLevelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否上门：">
          <el-radio-group v-model="serverObj.visited">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <!-- 补充资料 -->
    <div v-show="display === 4">
      <div style="height: 12px; margin-top: 30px; color: #169bd5">补充资料</div>
      <el-divider></el-divider>
      <el-form label-width="180px" ref="form" disabled :model="serverinfoObj">
        <el-form-item label="上传录音：" prop="suppleRecord">
          <audio
            controls="controls"
            style="margin-left: 0"
            preload="auto"
            class="audioActive"
            :src="serverinfoObj.suppleRecord"
          ></audio>
        </el-form-item>
        <el-form-item label="上传视频：" prop="suppleVideo">
          <div class="uploadBox">
            <div class="uploadFlex">
              <video
                id="myvideo1"
                :src="serverinfoObj.suppleVideo"
                style="height: 200px; width: 300px; margin: 0 10px"
                ref="videoId"
                autoplay="true"
                controls
                muted
              ></video>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="上传图片：" prop="supplePic">
          <el-upload
            :action="actionUrl"
            :file-list="fileList"
            list-type="picture-card"
            :limit="10"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <div class="btn">
      <div>
        <el-button v-if="dealFlag" type="primary" @click="dealSend"
          >处理</el-button
        >
        <el-button @click="closeWindow" type="info">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import request from "@/utils/request.js"
import CustomerList from "../component/customerList.vue"
import ChanPinList from "../component/chanPinList.vue"
import ServeStation from "../component/serveStation.vue"
import CallbackVisitDialog from "../component/callbackVisitDialog"
import exportVue from "@/utils/exportVue"
import audioLink from "@/api/audio"
import baseURL from "@/api/baseURL"
export default {
  components: {
    CustomerList,
    ChanPinList,
    ServeStation,
    CallbackVisitDialog,
  },
  name: "visitDialogs",

  props: {
    showVisit: {
      type: Boolean,
      default: false,
    },
    showTitle: {
      type: String,
      default: "",
    },
    orderInfo: {
      type: Object,
      default: {},
    },
    dealFlag: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      checkList: [],
      fileList: [],
      showCard: false,
      volunteer: false,
      franchisee: false,
      otherServePerson: false,
      qtlxfs: false,
      imageUrl: "",
      radio: "",
      showAddStatus: false,
      showChanpin: false,
      showStation: false,
      showSallianceBusiness: false,
      jiamengTemp: "",
      showServeName: false,
      showServeName1: false,
      serveName1: "",
      showVolunteer: false,
      franchiseename: "",
      tempJiameng: "",
      actionUrl: baseURL + "/jjyl/controller/uploadController/info/uploadPhoto",
      rules: {
        name: [
          {
            required: true,
            message: "请输入客户名称",
            trigger: "input",
          },
        ],
        customerType: [
          {
            required: true,
            message: "请选择工单类型",
            trigger: "blur",
          },
        ],
        contactrName: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur",
          },
        ],
        erviceType: [
          {
            required: true,
            message: "请输入套餐类型",
            trigger: "blur",
          },
        ],
        serviceType: [
          {
            required: true,
            message: "请选择服务种类",
            trigger: "blur",
          },
        ],
        serveproductName: [
          {
            required: true,
            message: "请选择服务项目",
            trigger: "input",
          },
        ],
        sertime: [{ required: true, message: "该项必填", trigger: "blur" }],
        ensure: [
          {
            required: true,
            message: "请选择套餐类型",
            trigger: "blur",
          },
        ],
        // number: [{required: true, message: "该项必填", trigger: "blur"}],
        servestationName: [
          { required: true, message: "该项必填", trigger: "input" },
        ],
        // statType: [{required: true, message: "该项必填", trigger: "blur"}],
        servePersonName: [
          { required: true, message: "该项必填", trigger: "input" },
        ],
        // franchisee: [{required: true, message: "该项必填", trigger: "blur"}],
        // otherServePerson: [
        //   {required: true, message: "该项必填", trigger: "blur"},
        // ],
        // volunteer: [{required: true, message: "该项必填", trigger: "blur"}],
      },
      // 套餐类型列表
      ensureList: [],
      serverinfoObj: {
        supplePic: [],
        suppleVideo: "",
        suppleRecord: "",
      },
      serviceTypeList: [],
      serverObj: {
        servestationName: "",
        period: "",
      },
      estimateLevelList: [
        { value: "1", label: "没有服务" },
        { value: "2", label: "不满意" },
        { value: "3", label: "服务一般" },
        { value: "4", label: "基本满意" },
        { value: "5", label: "非常满意" },
      ],
      display: 0,
      btnActive: true,
      allianceBusiness: {},
      jmTableData: [],
      serveName: "",
      serveNameTableData: [],
      serveName1TableData: [],
      volunteerName: "",
      volunteerTableData: [],
      serveNameTemp: "",
      volunteerTemp: "",
      // 选择的服务人员
      servePersonData: undefined,
      totalCount: 0,
      query: {
        pageNo: 1,
        pageSize: 5,
      },
      // 套餐类型应当选择的服务数量
      serviceNumber: 0,
    }
  },
  computed: {
    show() {
      return this.showVisit
    },
  },
  watch: {
    orderInfo(newVal) {
      if (newVal) {
        // 如果存在从属服务人员
        this.serverObj = JSON.parse(JSON.stringify(newVal))
        // this.serverObj.recVisit =
        //     audioLink + "/" + this.serverObj.recVisit
        if (this.serverObj.otherservePersonName) {
          this.serverObj.otherServePerson = "是"
          this.otherServePerson = true
        }
      }
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 点击处理
    dealSend() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      this.$post("/jjyl/servicePgd/info/Handle", {
        ...this.serverObj,
        states: 2,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("处理成功")
            this.$emit("updateList")
            this.closeWindow()
            loading.close()
          } else {
            this.$message.error("处理失败")
            this.$emit("updateList")
            this.closeWindow()
            loading.close()
          }
        })
        .catch((error) => {
          this.$emit("updateList")
          loading.close()
        })
    },
    // 套餐类型选择发生改变
    onEnsureChange(val) {
      if (val) {
        // 获取需要选择服务的数量
        for (let i = 0; i < this.ensureList.length; i++) {
          if (this.ensureList[i].id == val) {
            this.serviceNumber = this.ensureList[i].serviceNumber
            return
          }
        }
      }
    },
    // 获取套餐类型列表
    getEnsureList() {
      request({
        url: "/jjyl/admin/meal/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 9999,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.ensureList = res.content.list || []
          this.ensureList.forEach((item) => {
            item.id = item.id + ""
          })
        }
      })
    },
    //客户姓名回显
    sendCustomerName(data) {
      this.$set(this.serverObj, "customerName", data.customerName)
      this.$set(this.serverObj, "customer", data.customer)
    },
    //服务项目回显
    productNames(data) {
      if (Array.isArray(data) && data.length > 0) {
        let serveproductName = ""
        let serveProduct = ""
        let produce = ""
        data.forEach((item, index) => {
          if (index === data.length - 1) {
            serveproductName = serveproductName + item.productname
            serveProduct = serveProduct + item.id
            produce = produce + item.produce
          } else {
            serveproductName = serveproductName + item.productname + ","
            serveProduct = serveProduct + item.id + ","
            produce = produce + item.produce + ","
          }
        })
        this.$set(this.serverObj, "serveproductName", serveproductName)
        this.$set(this.serverObj, "serveProduct", serveProduct)
        this.$set(this.serverObj, "produce", produce)
      }
    },
    // 显示机构弹框
    inputClickStation() {
      if (this.showTitle === "查看") return
      this.showStation = true
      this.$nextTick(() => {
        this.$refs.ServeStation && this.$refs.ServeStation.getDataList()
      })
    },
    // 机构弹框内点击保存
    sendServestation(data) {
      this.$set(this.serverObj, "servestationName", data.statname)
      this.$set(this.serverObj, "servestationId", data.id)
    },
    // 选择服务项目
    inputClickChanPin() {
      if (this.showTitle === "查看") return
      if (!this.serverObj.servetypename) {
        this.$message.error("请先选择服务种类")
        return
      }
      this.showChanpin = true
      this.$refs.ChanPinList && this.$refs.ChanPinList.getDataList()
    },
    // 获取服务种类
    getServiceTypeList() {
      request({
        url: "/jjyl/admin/type/info/findList",
        method: "POST",
        data: {
          typeLevel: 0,
          pageSize: 1000,
          pageNo: 1,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.serviceTypeList = res.content || []
        } else {
          this.$message.error("获取服务种类失败")
        }
      })
    },
    // 保存选中的加盟商
    getJMS(val) {
      this.jiamengTemp = val
      this.getJMSList()
    },
    //加盟商表格分页
    jmSizeChange(val) {
      this.query.pageSize = val
      this.getJMSList()
    },
    // 加盟商列表页数改变
    jmCurrentChange(val) {
      this.query.pageNo = val
    },
    // 加盟商弹框点击保存
    jmSend() {
      if (!this.jiamengTemp) {
        this.$message.error("请选择一个加盟商")
        return
      }
      this.showSallianceBusiness = false
      this.$set(this.serverObj, "jiamengName", this.jiamengTemp.franchiseename)
      this.$set(this.serverObj, "jiamengId", this.jiamengTemp.id)
    },
    // 获取加盟商列表
    getJMSList() {
      request({
        url: "/jjyl/FranchiserController/info/findFranchiser",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          type: 1,
          franchiseename: this.franchiseename,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.jmTableData = res.content.list || []
          this.totalCount = res.content.count || 0
        } else {
          this.$message.info("当前机构下暂无加盟商")
        }
      })
    },
    // 显示加盟商选择弹框
    servestationNameFn() {
      if (this.showTitle === "查看") return
      this.showSallianceBusiness = true
      this.getJMSList()
    },
    // 关闭加盟商弹框
    onJMSClose() {
      this.showSallianceBusiness = false
      this.franchiseename = ""
      this.tempJiameng = ""
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
    },
    onVolunteerClose() {
      // 志愿者弹框关闭
      this.showVolunteer = false
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
      this.volunteerTemp = []
    },
    // 志愿者
    voluteerNameFn() {
      if (this.showTitle === "查看") return
      this.showVolunteer = true
      this.getVoluteerList()
    },
    // 获取志愿者
    getVoluteerList() {
      request({
        url: "/jjyl/admin/volunteerArchive/info/list",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          gridId: this.$store.state.info.gridId,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.volunteerTableData = res.content.list || []
          this.totalCount = res.content.count || 0
        } else {
          this.$message.error("获取志愿者失败")
        }
      })
    },
    // 从属服务人员
    serveNameFn() {
      if (this.showTitle === "查看") return
      if (!this.serverObj.servestationId) {
        this.$message.error("请先选择机构")
        return
      }
      this.showServeName = true
      this.getServeNameDataList()
    },
    // 显示服务人员弹框
    serveName1Fn() {
      if (this.showTitle === "查看") return
      if (!this.serverObj.servestationId) {
        this.$message.error("请先选择机构")
        return
      }
      this.showServeName1 = true
      this.getServeName1DataList()
    },
    // 服务人员页码切换
    serveName1SizeChange(val) {
      this.query.pageSize = val
      this.getServeName1DataList()
    },
    serveName1CurrentChange(val) {
      this.query.pageNo = val
      this.getServeName1DataList()
    },
    // 从属服务人员表格分页
    serveNameSizeChange(val) {
      this.query.pageSize = val
      this.getServeNameDataList()
    },
    serveNameCurrentChange(val) {
      this.query.pageNo = val
      this.getServeNameDataList()
    },
    //服务人员的表格获取
    getServeName1DataList() {
      request({
        url: "/jjyl/WebServestation/info/findServePersonByServestationId",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          servestationId: this.serverObj.servestationId,
          name: this.serveName1,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.serveName1TableData = res.content.list || []
          this.totalCount = res.content.count || 0
        } else {
          this.$message.error("获取服务人员失败")
        }
      })
    },
    // 从属服务人员的表格获取
    getServeNameDataList() {
      request({
        url: "/jjyl/WebServestation/info/findServePersonByServestationId",
        method: "POST",
        data: {
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          servestationId: this.serverObj.servestationId,
          name: this.serveName,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          this.serveNameTableData = res.content.list || []
          this.totalCount = res.content.count || 0
        } else {
          this.$message.error("获取服务人员失败")
        }
      })
    },
    // 服务人员点击保存
    serveName1Send() {
      this.$set(this.serverObj, "servePersonName", this.servePersonData.name)
      this.$set(this.serverObj, "mobilePhone", this.servePersonData.mobilePhone)
      this.$set(this.serverObj, "servePersonID", this.servePersonData.id)
      this.showServeName1Close()
    },
    // 从属服务人员点击保存
    serveNameSend() {
      this.$set(
        this.serverObj,
        "otherservePersonName",
        this.servePersonData.name
      )
      // this.$set(this.serverObj, 'mobilePhone', this.servePersonData.mobilePhone)
      this.$set(this.serverObj, "otherservePersonID", this.servePersonData.id)
      this.showServeNameClose()
    },
    // 服务人员弹框关闭
    showServeName1Close() {
      this.showServeName1 = false
      this.serveName1 = ""
      this.serveName1TableData = []
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
    },
    // 从属服务人员弹框关闭
    showServeNameClose() {
      this.showServeName = false
      this.serveName = ""
      this.serveNameTableData = []
      this.query = {
        pageNo: 1,
        pageSize: 5,
      }
      this.totalCount = 0
    },
    // 服务人员选择人员
    getServePersonName(val) {
      this.servePersonData = val
    },
    //志愿者
    volunteerSelectionChange(data) {
      this.volunteerTemp = data
    },
    //志愿者表格分页
    volunteerSizeChange(val) {
      this.query.pageSize = val
      this.getVoluteerList()
    },
    volunteerCurrentChange(val) {
      this.query.pageNo = val
      this.getVoluteerList()
    },
    volunteerSend() {
      if (this.volunteerTemp.length > 1) {
        this.$message.error("只能选择一个志愿者")
        return
      }
      this.showVolunteer = false
      if (this.volunteerTemp.length === 1) {
        this.$set(
          this.serverObj,
          "voluteerName",
          this.volunteerTemp[0].userName
        )
      }
    },
    getDataList() {
      request({
        url: "/jjyl/admin/type/info/findList",
        method: "POST",
        data: {
          belongAddressLevel: 2,
          pageNo: 1,
          pageSize: 1000,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.options = res.content
          } else {
            this.options = []
          }
        }
      })
    },
    // 选择客户姓名
    inputClickName() {
      if (this.showTitle === "查看") return
      this.showAddStatus = true
      this.$refs.Customer.getDataList()
    },
    handleAvatarSuccess1() {
      this.$set(this.serverObj, "pictureVisit", res.content)
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {},
    oldCard() {
      this.showCard = !this.showCard
    },
    otherTelephone(val) {
      this.qtlxfs = val == "1"
    },
    isFranchisee(val) {
      this.franchisee = val === "是"
    },
    isOtherServePerson(val) {
      this.otherServePerson = val === "是"
    },
    isVolunteer(val) {
      this.volunteer = val === "是"
    },
    send() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          delete this.serverObj.franchisee
          delete this.serverObj.otherServePerson
          delete this.serverObj.volunteer
          if (this.showTitle === "新增") {
            request({
              url: "/jjyl/servicePgd/info/addServicepgd",
              method: "POST",
              data: {
                ...this.serverObj,
                // otherservePersonID: null,
                // serveStation: null
              },
            }).then((res) => {
              if (res.code === 200) {
                this.closeWindow()
                this.$emit("updateList")
              }
            })
          } else {
            let states = "3"
            if (this.showTitle === "派发") {
              states = ""
            } else if (this.showTitle === "处理") {
              states = "2"
            } else if (this.showTitle === "回访") {
              states = "3"
            } else if (this.showTitle === "作废") {
              states = "5"
            } else if (this.showTitle === "申请作废") {
              states = "4"
            }
            request({
              url: "/jjyl/servicePgd/info/Visit",
              method: "POST",
              data: {
                ...this.serverObj,
                states: states,
              },
            }).then((res) => {
              if (res.code === 200) {
                this.closeWindow()
                this.$emit("updateList")
              }
            })
          }
        } else {
          return false
        }
      })
    },
    //派发
    payOut() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          delete this.serverObj.franchisee
          delete this.serverObj.otherServePerson
          delete this.serverObj.volunteer
          if (this.serverObj.servePersonID) {
            request({
              url: "/jjyl/servicePgd/info/insertAndDistribute",
              method: "POST",
              data: {
                ...this.serverObj,
                // otherservePersonID: null,
                // serveStation: null,
                states: 1,
              },
            }).then((res) => {
              if (res.code === 200) {
                this.closeWindow()
                this.$message.success("派发成功")
                this.$emit("updateList")
              } else {
                this.$message.success("派发失败")
              }
            })
          } else {
            // delete this.serverObj.servePersonName
            // delete this.serverObj.mobilePhone
            // delete this.serverObj.servePersonID
            // this.$message.error('请选择服务人员')
            // return
            request({
              url: "/jjyl/servicePgd/info/Distribute",
              method: "POST",
              data: {
                ...this.serverObj,
                states: 1,
                id: this.serverObj.id,
              },
            }).then((res) => {
              if (res.code === 200) {
                this.closeWindow()
                this.$message.success("派发成功")
                this.$emit("updateList")
              } else {
                this.$message.success("派发失败")
              }
            })
          }
        } else {
          this.$message.error("请按照规则输入")
          return false
        }
      })
    },
    //派发
    sendMsg() {
      this.display = 0
    },
    //处理
    disposeMsg() {
      this.display = 1
    },
    //回访
    callbackMag() {
      this.display = 2
    },
    //补充资料
    InfoMag() {
      this.display = 4
      this.fileList = []
      request({
        url: "/jjyl/servicePgdSupple/info/get",
        method: "POST",
        data: {
          servicePgdId: this.serverObj.id,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content == null || res.content == "null") {
            this.serverinfoObj = {}
          } else {
            this.serverinfoObj = res.content
            this.serverinfoObj.suppleRecord = res.content.suppleRecord
            this.serverinfoObj.suppleVideo = res.content.suppleVideo
            if (this.serverinfoObj.supplePic.length > 0) {
              this.serverinfoObj.supplePic =
                this.serverinfoObj.supplePic.split(",")
              this.fileList = this.serverinfoObj.supplePic.map((item) => {
                return {
                  url: item,
                }
              })
            }
          }
        }
      })
    },
    //回访中
    callbackingMag() {
      this.display = 3
    },
    // 回访弹框关闭
    handleClose() {
      this.display = 0
      this.dialogVisible = false
      this.serverObj = {}
      if (this.$refs.CallbackVisitDialog) {
        this.$refs.CallbackVisitDialog.changeContent = []
      }
    },
    closeWindow() {
      this.$emit("update:showVisit", false)
      this.display = 0
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
      this.serverObj = {}
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
      })
      this.qtlxfs = false
      this.franchisee = false
      this.otherServePerson = false
      this.volunteer = false
      // 套餐类型应当选择的服务数量为0
      this.serviceNumber = 0
    },
    //不合格事件
    disqualificationFun(data) {
      this.btnActive = data !== "不合格"
    },
    //打电话
    callPhone(phone, type) {
      if (phone == null || phone == "") {
        this.$message.warning("号码无效，暂无法拨号")
      } else {
        this.$store.dispatch("setPhone", phone)
        exportVue.$emit("question", true)
        setTimeout(() => {
          this.callType(phone, type)
        }, 5000)
      }
    },
    // 拨号处理
    callType(phone, type) {
      const self = this
      request({
        url: "/jjyl/traffic/callInfo/info/saveCallIdforNormalPdg",
        method: "POST",
        data: {
          remoteNum: phone,
          agentID: self.$store.state.seatNo,
          servicepgdId: self.dataId,
          callToType: type,
        },
      }).then((res) => {})
    },
  },
}
</script>
<style lang="less" scoped>
.dialog_container {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }
}

.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}

.add-ent {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.add-ent > div {
  width: 48%;
}

.add-title1 {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.add-title1 > div:first-child {
  width: 120px;
  text-align: right;
}

.add-title1 > div:nth-child(2) {
  width: calc(100% - 120px);
}

.visit-image {
  width: 60%;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.image-title {
  width: 178px;
  margin-top: 10px;
  text-align: center;
}

.cu-title1 {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.cu-title1 > div {
  width: 50%;
}

.cu-title2 {
  display: flex;
  align-items: center;
}

.cu-title2 > div:first-child {
  width: 80px;
  text-align: center;
}

.audioActive {
  margin-left: 180px;
  margin-bottom: 20px;
}

.cu-title2 > div:nth-child(2) {
  width: calc(100% - 80px);
}

.cu-title3 {
  margin-left: 30px;
}
</style>
<style lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.dialogBtns {
  display: flex;
  justify-content: center;
  margin: 15px 0;

  .el-button {
    margin-right: 40px;
  }
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.imgBox {
  height: 200px;
  width: 150px;

  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .img {
    margin-bottom: 10px;
    width: 100px;
    height: 100px;
  }

  .photoName {
    width: 70%;
    background-color: #169bd5;
    color: #ffffff;
    text-align: center;
    border-radius: 5px;
  }
}
</style>
